var request = new XMLHttpRequest();

request.onreadystatechange = function() {
  if(request.readyState === 4) {

    if(request.status === 200) {

      var modal_spinner = document.querySelector('.modal-spinner');
      if(modal_spinner) {
        modal_spinner.parentNode.removeChild(modal_spinner);
      }

      var responseHTML = document.createElement('div');
      responseHTML.innerHTML = request.responseText;
      var element = responseHTML.querySelector('.hentry').outerHTML;

      var modal_content = document.querySelector('.modal-content');
      if(modal_content) {
        modal_content.innerHTML = element;
      }

    } else {
      console.log('An error occurred during your request: ' +  request.status + ' ' + request.statusText);
    }
  }
}

var els = document.querySelectorAll('.modal-open');
for(i = 0; i < els.length; i++) {
  els[i].addEventListener('click', function(e) {
    e.preventDefault();
    // var currentState = history.state;
    // window.history.pushState( currentState, '', this.getAttribute('href') );
    // var body = document.getElementsByTagName('body')[0];

    // create modal
    var modal = document.createElement('div');
    modal.setAttribute('id', 'modal');

    // create close button, append it to modal
    var close_modal_button = document.createElement('a');
    close_modal_button.classList.add('modal-close');
    close_modal_button.innerHTML = 'Sulje';
    // close_modal_button.setAttribute('href', '#');
    modal.appendChild( close_modal_button );

    // Add event listener for close button
    close_modal_button.addEventListener('click', function(e) {
      e.preventDefault();
      if( modal.classList.contains('open') ) {
        // Hide modal
        modal.classList.remove('open');
        document.body.classList.remove('modal-open');

        // Remove modal
        modal.parentNode.removeChild(modal);
      }
    });

    // Add content container
    var modal_content = document.createElement('div');
    modal_content.classList.add('modal-content');

    // Add loading spinner
    var modal_loading = document.createElement('div');
    modal_loading.classList.add('modal-spinner');
    modal_content.appendChild( modal_loading );

    modal.appendChild( modal_content );

    document.body.appendChild( modal );
    modal.classList.add('open');

    document.body.classList.add('modal-open');

    request.open('get', this.getAttribute('href'));
    request.send();
  })
}
